import { IApp } from "../../../../../../App/Typings/AbacApp";
import { ITableColumn } from "../../../../../../App/Typings/Table";
import { useGetAllAttributesForAbacAppQuery } from "../../../../AbacAppQueries";
import useCreateAttributeFormState from "./CreateAttributeFormState";

export default function useAbacAttributesState(app: IApp) {
  const { data: attributes = [], isLoading: isAttributeListLoading } =
    useGetAllAttributesForAbacAppQuery(app.id);
  const {
    getters: { createAttributeFormTitle, createIsLoading, formik },
    handlers: { handleCreateModalClose },
  } = useCreateAttributeFormState(app.id);

  const columns: ITableColumn[] = [
    { label: "Attribute Name", propName: "name" },
    { label: "Last Updated", propName: "updatedDate" },
    { label: "Is Active", propName: "isActive" },
  ];

  return {
    getters: {
      attributes,
      columns,
      isAttributeListLoading,
      createAttributeFormTitle,
      createIsLoading,
      formik,
    },
    handlers: {
      handleCreateModalClose,
    },
  };
}
